import React from 'react';

const LoadingComponent = ( { text } ) => {
	return (
		<div>{ text || 'Loading' }<span className="loadingdot bounce1">.</span><span className="loadingdot bounce2">.</span><span className="loadingdot">.</span></div>
	);
};

export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/components/header/LoadingComponent.js